<div *ngIf="!status" style="width: 100%; height: 100%; position: absolute; z-index: 1;"></div>
<div class="row" *ngIf="data.current !== undefined">
  <h4>{{ data.display_name || data.name }}
    <span class="badge badge-info">{{ data.current | transformEndpointValues:data || 0 }}</span>
  </h4>
  <div class="col-md-12">
    <input (mouseup)="onChangeDimmer(data.current)" [(ngModel)]="data.current" [value]="data.current"
      class="form-control" type="range" min="0" max="255" step="1">
  </div>
</div>